const key = 'login-redirect';

export const setLoginRedirect = (path) => {
  return window.sessionStorage.setItem(key, path);
};

export const getLoginRedirect = () => {
  const result = window.sessionStorage.getItem(key) || null;

  window.sessionStorage.removeItem(key);

  return (result !== '/profile') ? result : null;
};
